import React from 'react';

import { PackageConfig } from '../types';

interface PackageCardProps {
  pkg: PackageConfig;
  revealed: boolean;
  shining: boolean;
  expanded: boolean;
  selected: boolean;
  tagsVisible: boolean;
  onSelect: (id: string) => void;
  compact?: boolean;
}

export const PackageCard: React.FC<PackageCardProps> = ({
  pkg,
  revealed,
  shining,
  expanded,
  selected,
  tagsVisible,
  onSelect,
  compact = false,
}) => {
  const classNames = [
    'ms-package-card',
    revealed ? 'revealed' : '',
    shining ? 'shining' : '',
    expanded ? 'expanded' : '',
    selected ? 'selected' : '',
    tagsVisible ? 'tags-visible' : '',
    compact ? 'compact' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const savings = pkg.originalPrice ? Math.round(((pkg.originalPrice - pkg.price) / pkg.originalPrice) * 100) : 0;

  return (
    <div className={classNames} onClick={() => onSelect(pkg.id)}>
      <div className="ms-pack-skeleton" />
      <div className="ms-pack-border-beam" />
      <div className="ms-pack-glow-bg" />
      <div className="ms-pack-content">
        <div>
          <div className="ms-pack-title-row">
            <h4 className="ms-pack-name">{pkg.name}</h4>
            {pkg.label && (
              <span className={`ms-pack-tag ${pkg.isSelected ? 'recommendation' : 'best-value'}`}>
                <span>{pkg.label}</span>
              </span>
            )}
            <div className="ms-pack-check-icon">
              <svg viewBox="0 0 12 12" fill="none">
                <path d="M3 6l2.5 2.5L9 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>
          <div className="ms-pack-desc-row">
            <span className="ms-pack-desc">{pkg.description}</span>
          </div>
        </div>
        {!compact && (
          <div className="ms-pack-price-area">
            {pkg.originalPrice && (
              <div className="ms-price-discount">
                <span className="ms-old-price">
                  {pkg.currency}{pkg.originalPrice}
                </span>
                <span className="ms-save-badge">Save {savings}%</span>
              </div>
            )}
            <div className="ms-price-main">
              <span className="ms-price-currency">{pkg.currency}</span>
              <span className="ms-price-amount">{pkg.price}</span>
              <span className="ms-price-period">{pkg.period}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
